const url_domain = window.location.host
let config_url = ''

if (url_domain == 'localhost:8080') {
  // config_url = 'http://127.0.0.1:3333/api/1.0'

  config_url = 'https://apicilara.myticktap.com/api/1.0'
} else if (url_domain == 'dashcilara.myticktap.com') {
  config_url = 'https://apicilara.myticktap.com/api/1.0'
}
else if (url_domain == 'dashmin.cilara.org.ve') {
  config_url = 'https://api.cilara.org.ve/api/1.0'
}

console.log('Backend Conected: ' + config_url)
export const apiPath = config_url
